import * as yup from "yup";
import { isDraftJsState } from "core/utils/json";
import isString from "lodash/isString";
import filter from "lodash/filter";

const notEmptyDraftJsContentTest = "notEmptyDraftJsContent";

yup.addMethod(yup.mixed, notEmptyDraftJsContentTest, function(a) {
  const { message } = a;
  return this.test(notEmptyDraftJsContentTest, message, function(value) {
    const { path, createError } = this;
    const isValid =
      isDraftJsState(value) &&
      value.blocks?.length > 0 &&
      filter(value.blocks, x => isString(x.text) && x.text.length > 0).length >=
        1 && // at least one is longer then one character.
      !/^ *$/.test(value.blocks.map(x => x.text).join("")); // check if the collection of blocks are not just whitespace

    return isValid || createError({ path, message });
  });
});

export function createTextEditorValidationRule(fieldName) {
  return yup
    .mixed(fieldName)
    .label(fieldName.charAt(0).toUpperCase() + fieldName.slice(1))
    .required("Required")
    .notEmptyDraftJsContent({ message: "Required" });
}
